import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject, map, tap } from 'rxjs';
import { environment } from 'environments/environment';
import { BaseResponse } from 'app/core/models/common.response';
import { TodoItem } from '../dashboard.types';
@Injectable({
    providedIn: 'root'
})
export class TodoService {

    private _todos: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    private _onTodoUpdate = new Subject<{action?: string, todo?: any, id?: string}>();

    constructor(private readonly _http: HttpClient) { }

    get onTodoUpdate$(): Observable<{action?: string, todo?: any, id?: string}> {
        return this._onTodoUpdate.asObservable();
    }

    notifyTodoUpdate(action?: string, todo?: any, id?: string): void {
        this._onTodoUpdate.next({ action, todo, id });
    }

    get todos$(): Observable<any[]> {
        return this._todos.asObservable();
    }

    // ────────────────────────────────────────────────────────────────────────
    // @ Todo API methods
    // ────────────────────────────────────────────────────────────────────────

    /** GET /Todo/GetTodoList */
    getTodos(): Observable<TodoItem[]> {
        return this._http
            .get<BaseResponse<TodoItem[]>>(`${environment.baseUrl}/Todo/GetTodoList`)
            .pipe(
                map((res) => res?.result ?? []),
                tap((todos) => this._todos.next(todos))
            );
    }

    /** GET /Todo/GetNotesListByCampId */
    getNotesByCampId(campId: string): Observable<TodoItem[]> {
        return this._http
            .get<BaseResponse<TodoItem[]>>(`${environment.baseUrl}/Camp/GetCampNoteByCampId/${campId}`)
            .pipe(map((res) => res?.result ?? []));
    }


    /** POST /Todo — create a new todo (id must be empty string) */
    createTodo(notes: any): Observable<TodoItem> {
        return this._http
            .post<BaseResponse<TodoItem>>(`${environment.baseUrl}/Todo`, notes)
            .pipe(map((res) => res?.result));
    }

    /** PUT /Todo — update an existing todo */
    updateTodo(todo: TodoItem): Observable<TodoItem> {
        return this._http
            .put<BaseResponse<TodoItem>>(`${environment.baseUrl}/Todo`, todo)
            .pipe(map((res) => res?.result));
    }

    /** POST /Todo/UpdateTodoStatus — toggle completion status */
    updateTodoStatus(id: string, isCompleted: boolean): Observable<any> {
        return this._http.post(`${environment.baseUrl}/Todo/UpdateTodoStatus`, {
            id,
            isCompleted,
        });
    }

    /** DELETE /Todo/{id} */
    deleteTodo(id: string): Observable<any> {
        return this._http.delete(`${environment.baseUrl}/Todo/${id}`);
    }
}
